import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = (props) => {
  return (
    <div className="pageNotFound">
      <div className="box">
        <h1 className="text">404</h1>
        <h1>Page Not Found</h1>
        <span>
          <Link to={"/login"}>Go To Login</Link>
        </span>
      </div>
    </div>
  );
};

export default PageNotFound;
